import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import colors from './colors.js';
import footerLogoTransparent from './nocturnists_logo_footer_transparent.png';

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(6),
    color: colors.pink,
    width: "100%",
    backgroundColor: colors.blue,
  },
  footerLogo: {
    marginRight: theme.spacing(2)
  },
  footerLogoImg: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  footerText: {
    color: colors.grey,
    textDecoration: "none",
    "&:hover": {
      color: colors.pink
    }
  },
}));


export const Footer = () => {
  const classes = useStyles();
  return (
    <Grid container justify="left" className={classes.footer}>
      <Grid item xs={8} sm={6} >
        <Grid container justify="left">
          <a className={classes.footerLogo} href="https://thenocturnists.com">
            <img className={classes.footerLogoImg} src={footerLogoTransparent} alt="header" />
          </a>
          <Typography align="left" variant="h6">
            <i>the</i><br/>
            NOCTURNISTS
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={4} sm={6}>
        <Grid container justify="left">
          <Grid item xs={12} sm={2} >
            <Typography align="left" variant="body1" paragraph>
              <a className={classes.footerText} href="https://thenocturnists.com/about">
                about
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} >
            <Typography align="left" variant="body1" paragraph>
              <a className={classes.footerText} href="https://thenocturnists.com/donate">
                donate
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} >
            <Typography align="left" variant="body1" paragraph>
              <a className={classes.footerText} href="https://thenocturnists.com/podcast">
                episodes
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} >
            <Typography align="left" variant="body1" paragraph>
              <a className={classes.footerText} href="https://thenocturnists.com/contact">
                contact
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} >
            <Typography align="left" variant="body1" paragraph>
              <a className={classes.footerText} href="https://thenocturnists.com/participate">
                participate
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
